/* eslint-disable eol-last */
window.acceleratedDataQueue = window.acceleratedDataQueue || [];
window.acceleratedDataQueue.push({
    // eslint-disable-next-line
    'ACC_TDT_Global_01': {
        var: {
            newText: {
                'einloggen': 'Login',
                'einkaufswagen': 'Warenkorb',
                'seitennavigation': 'Menü'
            }
        },
        mainExe_ACC_TDT_Global_01_V1() {
            document.querySelector('body').classList.add('ACC_TDT_Global_01__Page_Wrap_V2');
            document.querySelectorAll('#SiteHeader .header-layout .header-item--icons .site-nav__link--icon').forEach((ele) => {
                const textBox = ele.querySelector('.icon__fallback-text');
                if (!textBox) return;
                const textBoxText = textBox.textContent.toLowerCase().trim();
                const newText = this.var.newText[textBoxText];
                if (!newText) return;
                textBox.textContent = newText;
            });
            const mobNavShop = document.querySelector('ul.mobile-nav a#Label-pages-shop1');
            if (mobNavShop) mobNavShop.textContent = 'SHOP';
            const deskNavShop = document.querySelector('#SiteHeader .header-layout .header-item summary.site-nav__link[aria-controls="site-nav-item--1"]');
            if (deskNavShop) deskNavShop.childNodes[0].textContent = 'SHOP'
        },

        init() {
            this.runAt('#SiteHeader .header-layout .header-item--navigation', () => {
                this.mainExe_ACC_TDT_Global_01_V1();
            });
        }
    }
});